import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack } from '@mui/material'
import { TextField } from '~/components'
import Field from './Field'
import { useCopyViewerText, useParagraphContext } from './hooks'
import Preview from './Preview'

const Movie = () => {
  const { t } = useTranslation()

  const { canEdit, editable, paragraph } = useParagraphContext(Movie.name)
  const copyViewerText = useCopyViewerText(canEdit)
  const viewerFieldSx = useMemo(
    () => (canEdit ? undefined : { cursor: 'pointer' }),
    [canEdit]
  )

  const [imageError, setImageError] = useState()

  return (
    <Stack spacing={0.5}>
      <Stack spacing={0.25}>
        {paragraph.embed && (
          <Box
            sx={{
              aspectRatio: 16 / 9,
              border: (theme) =>
                `1px solid ${theme.palette.input.border.default}`,
              borderRadius: '4px',
              overflow: 'clip',
            }}
          >
            <iframe
              allowFullScreen
              src={paragraph.embed}
              style={{
                border: 'none',
                width: '100%',
                height: '100%',
              }}
            />
          </Box>
        )}
        <Field
          name="media"
          render={(fieldProps) => (
            <Box
              onClick={() => copyViewerText(paragraph.media)}
              sx={viewerFieldSx}
            >
              <TextField
                editable={editable}
                placeholder={t('paragraph.movie.url')}
                size="small"
                value={paragraph.media || ''}
                {...fieldProps}
                onChange={({ target: { value } }) => {
                  if (/youtube\.com/.test(value)) {
                    value = value.replace(/watch\?v=/, 'embed/')
                  }
                  fieldProps.onChange?.({ target: { value } })
                }}
              />
            </Box>
          )}
        />
      </Stack>
      <Preview imageError={imageError} setImageError={setImageError} />
    </Stack>
  )
}

export default Movie
